import React, { useEffect, useState } from "react";
import CenterLoading from "components/core/CenterLoading";
import users, { AssociateReviewDtoV4 } from "services/users";
import CustomTable from "./worksites/projects/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const AdminReviews = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [reviewList, setReviewList] = useState<AssociateReviewDtoV4[]>([]);

  const getReviewsList = async () => {
    setIsLoading(true);
    try {
      const response = await users.getAdminReviewsV4();
      setReviewList(response);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const handleReview = async (id: number, status: "approved" | "rejected") => {
    const payload = { status };
    setIsLoading(true);
    try {
      const response = await users.sendAdminReviewV4(id, payload);
      if (response) {
        getReviewsList();
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getReviewsList();
  }, []);

  return (
    <div className="content-section poppins p-3 p-md-5">
      <CenterLoading isVisible={isLoading} />
      <h1 className="h1-text font-color-black">Admin Reviews</h1>
      {reviewList.length > 0 && (
        <CustomTable<AssociateReviewDtoV4>
          columnList={[
            {
              id: "comments",
              className: "col-4 lh-2 py-2",
              header: "COMMENTS",
              accessor: (item) => {
                return item.comments;
              },
            },
            {
              id: "createdByCompany",
              header: "COMPANY NAME",
              accessor: (item) => {
                return item.createdByCompany;
              },
              className: "col-2 lh-2 py-2",
            },
            {
              id: "rating",
              className: "col-1 lh-2 py-2",
              header: "RATINGS",
              accessor: (item) => {
                return (
                  <div
                    className="stars d-flex align-items-center"
                    style={{ gap: "2px" }}
                  >
                    {Array.from({ length: item.rating }).map((_, index) => (
                      <FontAwesomeIcon
                        key={index}
                        icon={faStar}
                        color="#1D65A6"
                        fontSize={12}
                      />
                    ))}
                  </div>
                );
              },
            },
            {
              header: "STATUS",
              id: "status",
              className: "col-1 lh-2 py-2",
              accessor: (item) => {
                return item.status;
              },
            },
            {
              id: "createdOn",
              header: "CREATED ON",
              accessor: (item) => {
                return item.createdOn
                  ? moment(item.createdOn).format("DD MMM YYYY")
                  : "N/A";
              },
              className: "col-2 lh-2 py-2",
            },
            {
              id: "actions",
              header: "ACTIONS",
              className: "col-2 lh-2 py-2",
              accessor: (item) => {
                return (
                  <div className="d-flex items-center gap-2">
                    <button
                      type="button"
                      className="btn primary-btn-sm"
                      onClick={() => handleReview(item.id, "approved")}
                    >
                      Accept
                    </button>
                    <button
                      type="button"
                      className="btn fw-bold border-0 danger-btn-sm"
                      onClick={() => handleReview(item.id, "rejected")}
                    >
                      Reject
                    </button>
                  </div>
                );
              },
            },
          ]}
          serverData={reviewList}
          pageSize200={true}
          selectable={false}
          className="table poppins table-bordered"
          tdClassName={"py-1"}
          selectedRows={[]}
          onRowClicked={() => {}}
        ></CustomTable>
      )}
    </div>
  );
};

export default AdminReviews;
